var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleColorGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-512,-320)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icons",
    x: 0,
    y: 0,
    width: 1280,
    height: 800,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons1"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Strike"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "H1"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "H2"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "H3"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "list-ul"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "hamburger-1"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "hamburger-2"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "list-ol"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "list-task"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "vertical-menu"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "horizontal-menu"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "sidebar-2"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Pen"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Pen1"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "clock"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "external-link"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "hr"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "info"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "warning"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "plus-circle"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "minus-circle"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "vue"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "cog"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "radio-check"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "eye-slash"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "eye"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "toggle-off"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "shredder"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "spinner--loading--dots-"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "react"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check-selected"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.10009,1.645e-33,1.645e-33,0.10009,511.942,319.993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.714,559.995C383.452,559.4 444.576,533.825 488.528,490.39C540.728,438.804 567.614,362.474 558.237,289.61C542.165,164.734 439.517,80 320.172,80C229.504,80 141.375,136.719 102.723,218.967C73.131,281.935 73.079,357.952 102.723,421.033C141.101,502.698 227.781,559.119 318.63,559.995C319.658,559.998 320.686,559.998 321.714,559.995ZM318.887,519.994C226.669,519.105 140.633,447.794 123.527,356.366C111.467,291.905 134.234,222.15 181.658,176.375C237.036,122.923 324.063,105.014 396.424,135.314C461.174,162.428 509.632,225.368 518.562,294.718C526.216,354.158 504.885,416.454 462.966,459.367C426.2,497.004 374.636,519.481 321.457,519.994C320.6,519.997 319.744,519.997 318.887,519.994Z",
    style: {
      fillRule: "nonzero"
    }
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20036,0,0,1.20036,-108.995,-70.5272)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#383A40",
    cx: 543.992,
    cy: 352,
    r: 14.13
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "turn-off"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "code-block"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "user"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.638317,0.368532,-0.368532,0.638317,785.021,-208.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-beans"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean1"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean-filled"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.638317,0.368532,-0.368532,0.638317,913.062,-208.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-beans-filled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coffee-bean2"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,128.011,1.35415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-paste"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "clipboard-copy"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleColorGrey);
export default __webpack_public_path__ + "static/media_static/circle-color-grey.fd50732bebdcd44421dbcae10a69fd77.svg";
export { ForwardRef as ReactComponent };